'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../node_modules/classnames/index.js');

var lanl_footer_logo_inline = require('../../../assets/svg/lanl_footer_logo.inline.svg.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var FooterContact = function FooterContact() {
  var contact = [{
    label: 'Los Alamos National Laboratory'
  }, {
    label: 'P.O. Box 1663 '
  }, {
    label: 'Los Alamos, NM 87545'
  }, {
    label: '(505) 667-5061'
  }];
  var social = [{
    icon: 'fab fa-facebook-f',
    link: 'https://www.facebook.com/LosAlamosNationalLab'
  }, {
    icon: 'fab fa-twitter',
    link: 'https://twitter.com/LosAlamosNatLab'
  }, {
    icon: 'fab fa-linkedin',
    link: 'https://www.linkedin.com/company/los-alamos-national-laboratory?trk=NUS_CMPY_FOL-co'
  }, {
    icon: 'fab fa-youtube',
    link: 'https://www.youtube.com/user/LosAlamosNationalLab'
  }, {
    icon: 'fab fa-instagram',
    link: 'https://www.instagram.com/losalamosnatlab'
  }];
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: "lanl-ft-contact-col",
    className: "lanl-footer-div"
  }, /*#__PURE__*/React__default['default'].createElement(lanl_footer_logo_inline['default'], {
    className: "img-fluid mx-auto"
  }), contact.map(function (_ref) {
    var label = _ref.label;
    return /*#__PURE__*/React__default['default'].createElement("p", {
      key: label
    }, label);
  }), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: "list-unstyled ft-social-list me-auto d-flex"
  }, social.map(function (_ref2) {
    var icon = _ref2.icon,
        link = _ref2.link;
    _ref2.testId;
    var socialClass = index['default'](icon, 'fa-lg me-4');
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: icon
    }, /*#__PURE__*/React__default['default'].createElement("a", {
      href: link,
      type: 'button',
      "data-testid": 'link ' + icon,
      "aria-label": 'Go to ' + link
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: socialClass,
      "data-testid": icon
    })));
  })));
};

exports.FooterContact = FooterContact;
exports['default'] = FooterContact;